import React from "react"
import { Col, Row } from "react-bootstrap"
import AccordionCard from "./AccordionCard"
import TestCardProps from "./TestCardProps"
import CardRow from "./CardRow"
import FormatDate from "../../../../formatters/FormatDate"

export default function CollectionCard(props: TestCardProps) {
  const { data } = props
  const title = <Row>
    <Col xs={5} sm={3}>COLLECTION</Col>
    <Col xs={3} sm={5}>{data.DateCollected ? data.CollectionStatusDescription : ""}</Col>
    <Col xs={4} sm={4}>{data.DateCollected ? FormatDate(data.DateCollected) : ""}</Col>
  </Row>
  return (
    <AccordionCard eventKey="collection" title={title}>
      <CardRow title="SITE" value={data.CollectorVendorName}/>
      <CardRow title="COLLECTOR" value={data.CollectedBy}/>
      <CardRow title="SPECIMEN/REFERENCE ID" value={data.SampleID}/>
      <CardRow title="SPLIT SPECIMEN" value={data.SplitSpecimen} bool/>
      <CardRow title="ARRIVED DATE" value={data.DateArrived} date/>
      <CardRow title="ARRIVED TIME" value={data.DateArrived} time/>
      <CardRow title="COLLECTED DATE" value={data.DateCollected} date/>
      <CardRow title="COLLECTED TIME" value={data.DateCollected} time/>
    </AccordionCard>
  )
}
